class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((type, event) => {
      this.onSubmitHandler(event, type);
    }, 800);

    const facetForm = this.querySelector('form');

    // Remove the input event listener to prevent immediate filtering
    // facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    // Only apply sort changes immediately
    const sortInputs = facetForm.querySelectorAll('input[name="sort_by"]');
    sortInputs.forEach((input) => {
      input.addEventListener('change', this.debouncedOnSubmit.bind(this));
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.sortDetails = facetForm.querySelector('details.sort__details');
    this.sortValueInput = facetForm.querySelector('#sortValue');

    // Initialize the apply button handler
    this.initApplyButtonHandler();

    // Call the function to add the sorting logic
    this.initSortHandler();
  }

  // Add new method to handle the apply button
  initApplyButtonHandler() {
    const applyBtn = this.querySelector('.apply__btn');
    if (applyBtn) {
      applyBtn.addEventListener('click', (event) => {
        // Prevent the default action of closing the drawer
        event.preventDefault();

        // Get the form
        const form = this.querySelector('form');
        if (form) {
          // Create a URLSearchParams object to hold all parameters
          const formData = new URLSearchParams();

          // Add all filter parameters from the current form
          const currentFormData = new FormData(form);
          for (const [key, value] of currentFormData.entries()) {
            formData.append(key, value);
          }

          // Check if we need to preserve sort parameter from other forms
          const sortInput = document.querySelector('input[name="sort_by"]:checked, #sortValue');
          if (sortInput && !formData.has('sort_by')) {
            formData.append('sort_by', sortInput.value);
          }

          // Submit with all parameters
          this.onSubmitForm(formData.toString(), event);

          // Close the mobile drawer
          const summary = this.querySelector('summary.mobile-facets__open-wrapper');
          if (summary) summary.click();
        }
      });
    }
  }

  // Add method to handle collection bubble changes
  handleCollectionChange(event) {
    const target = event.currentTarget;
    const collectionUrl = target.getAttribute('data-url');

    if (collectionUrl) {
      // Remove active class from all collection bubbles
      document.querySelectorAll('.bubble__item').forEach((element) => {
        element.classList.remove('is-active');
      });

      // Add active class to current bubble
      target.classList.add('is-active');

      // Trigger collection change with empty search params to reset filters
      this.debouncedOnSubmit('collection', event);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false, 'facets');
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // Function to initialize the sort handler
  initSortHandler() {
    if (!this.sortDetails || !this.sortValueInput) return;
    let tempThis = this;
    this.sortDetails.addEventListener('click', (event) => {
      const target = event.target;
      // Check if the clicked element is a sort option
      if (target.classList.contains('sort-option') && target.hasAttribute('data-value')) {
        // Prevent the default action
        event.preventDefault();
        event.stopPropagation();

        this.sortDetails.querySelectorAll('.sort-option').forEach((item) => {
          item.classList.remove('is-active');
        });
        target.classList.add('is-active');
        const sortValue = target.getAttribute('data-value');
        // Update the hidden input value
        tempThis.sortValueInput.value = sortValue;

        // Collect all form data to preserve filters
        const allFilterForms = document.querySelectorAll('facet-filters-form form');
        const formData = new URLSearchParams();

        // First add the sort value to our form data
        formData.append('sort_by', sortValue);

        // Then add all other filter parameters from all applicable forms
        allFilterForms.forEach((form) => {
          if (form.id === 'FacetFiltersForm' || form.id === 'FacetFiltersFormMobile') {
            const data = new FormData(form);
            for (const [key, value] of data.entries()) {
              // Don't duplicate the sort parameter
              if (key !== 'sort_by') {
                formData.append(key, value);
              }
            }
          }
        });

        // Submit with combined parameters
        tempThis.onSubmitForm(formData.toString(), event);
        return false;
      }
    });
  }

  static renderPage(searchParams, event, updateURLHash = true, type = 'facets') {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      if (type === 'collection') {
        url = `${event.target.dataset.url}?section_id=${section.section}&${searchParams}`;
      }
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, section.type)
        : FacetFiltersForm.renderSectionFromFetch(url, event, section.type);
    });

    if (updateURLHash)
      FacetFiltersForm.updateURLHash(searchParams, type, type === 'collection' ? event.target.dataset.url : '');
  }

  static renderSectionFromFetch(url, event, type) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (type === 'product') {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        } else if (type === 'main-collection-banner') {
          FacetFiltersForm.renderProductGridBanner(html);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderSectionFromCache(filterDataUrl, event, type) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    if (type === 'product') {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    } else if (type === 'main-collection-banner') {
      FacetFiltersForm.renderProductGridBanner(html);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    document.dispatchEvent(new CustomEvent('grid-updated'));
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderProductGridBanner(html) {
    if (document.getElementById('main-collection-banner'))
      document.getElementById('main-collection-banner').innerHTML = new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('main-collection-banner').innerHTML;
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.sorting', '.active_count', '.mobile-facets__footer'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    if (document.getElementById('FacetFiltersFormMobile')) {
      const menuDrawer = document.getElementById('FacetFiltersFormMobile').closest('menu-drawer');
      menuDrawer.bindEvents();

      // Re-initialize the apply button handler after rendering
      const facetFiltersForm = menuDrawer.querySelector('facet-filters-form');
      if (facetFiltersForm && typeof facetFiltersForm.initApplyButtonHandler === 'function') {
        facetFiltersForm.initApplyButtonHandler();
      }
    }
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams, type = 'facets', collectionPath = '') {
    let url = window.location.pathname;
    if (type === 'collection') {
      url = collectionPath;
    }
    history.pushState({ searchParams }, '', `${url}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
        type: 'product',
      },
      {
        section: document.getElementById('main-collection-banner')
          ? document.getElementById('main-collection-banner').dataset.id
          : '',
        type: 'main-collection-banner',
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event, type = 'facets') {
    FacetFiltersForm.renderPage(searchParams, event, true, type);
  }

  onSubmitHandler(event, type = 'facets') {
    event.preventDefault();

    if (type === 'collection') {
      // For collection changes, preserve current filters
      const sortFilterForms = document.querySelectorAll('facet-filters-form form');
      const forms = [];

      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetFiltersForm' || form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });

      const searchParams = forms.join('&');
      this.onSubmitForm(searchParams, event, type);
      return;
    }

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    // Keep immediate filtering for sort changes only
    if (event.target && event.target.name === 'sort_by') {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    } else if (!event.target || !event.target.closest('.mobile-facets__footer')) {
      // Only proceed with immediate filtering if NOT from a checkbox or if explicitly from the apply button
      if (event.type === 'submit' || event.originalTarget?.classList?.contains('apply__btn')) {
        const forms = [];
        const isMobile = event.target?.closest('form')?.id === 'FacetFiltersFormMobile';

        sortFilterForms.forEach((form) => {
          if (!isMobile) {
            if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
              forms.push(this.createSearchParams(form));
            }
          } else if (form.id === 'FacetFiltersFormMobile') {
            forms.push(this.createSearchParams(form));
          }
        });
        this.onSubmitForm(forms.join('&'), event);
      }
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url, event, true, 'facets');
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('DOMContentLoaded', () => {
  const sortDetails = document.getElementById('sortDetails');
  const sortValueInput = document.getElementById('sortValue');
  const sortForm = document.getElementById('sortForm');

  if (sortDetails) {
    sortDetails.addEventListener('click', (event) => {
      const target = event.target;

      // Check if the clicked element is a sortable option
      if (target.tagName === 'LI' && target.hasAttribute('data-value')) {
        // Prevent default form submission
        event.preventDefault();

        const sortValue = target.getAttribute('data-value');
        sortValueInput.value = sortValue;

        // Use the FacetFiltersForm instance to handle the submission
        // This ensures filters are preserved
        const facetFiltersForm = document.querySelector('facet-filters-form');
        if (facetFiltersForm) {
          // Collect all form data including filters
          const allFilterForms = document.querySelectorAll('facet-filters-form form');
          const formData = new URLSearchParams();

          // Add sort value
          formData.append('sort_by', sortValue);

          // Add all filter parameters
          allFilterForms.forEach((form) => {
            if (form.id === 'FacetFiltersForm' || form.id === 'FacetFiltersFormMobile') {
              const data = new FormData(form);
              for (const [key, value] of data.entries()) {
                if (key !== 'sort_by') {
                  formData.append(key, value);
                }
              }
            }
          });

          facetFiltersForm.onSubmitForm(formData.toString(), event, 'facets');
        }
      }
    });
  }
});
